import settingsReducer from './settingsReducer';
import clientInfoReducer from './clientInfoReducer';
import businessCardReducer from './businessCardReducer';

export {settingsReducer,clientInfoReducer,businessCardReducer};
export default businessCardReducer;
